import type {
  ContentSubmissionRow,
  ContentSubmission,
  ContentFolderRow,
  ContentFolder,
  ContentImageRow,
  ContentImage,
  PerformanceMetrics,
  ContentPlatform,
  ContentType,
  ContentStatus,
  ScrapeStatus,
} from '../types/content.types';

export function mapDbRowToContentSubmission(row: ContentSubmissionRow): ContentSubmission {
  return {
    id: row.id,
    campaign_influencer_id: row.campaign_influencer_id,
    platform: row.platform as ContentPlatform,
    type: row.type as ContentType,
    status: (row.status || 'draft') as ContentStatus,
    post_url: row.post_url,
    posted_at: row.posted_at,
    submission_url: row.submission_url,
    performance_metrics: (row.performance_metrics as PerformanceMetrics | null) || null,
    submitted_on: row.submitted_on,
    approved_on: row.approved_on,
    approved_by: row.approved_by,
    rejection_reason: row.rejection_reason,
    scrape_status: (row.scrape_status || 'none') as ScrapeStatus,
    scrape_started_at: row.scrape_started_at,
    scrape_completed_at: row.scrape_completed_at,
    scrape_error: row.scrape_error,
    scrape_retry_count: row.scrape_retry_count ?? 0,
    last_scraped_at: row.last_scraped_at,
    er_followers: (row as any).er_followers ?? null,
    is_pinned: Boolean((row as any).is_pinned),
    thumbnail_url: row.thumbnail_url,
    created_at: row.created_at || new Date().toISOString(),
    updated_at: row.updated_at,
  };
}

export function mapDbRowToContentFolder(row: ContentFolderRow): ContentFolder {
  return {
    id: row.id,
    campaign_id: row.campaign_id,
    organization_id: row.organization_id,
    name: row.name,
    created_at: row.created_at || new Date().toISOString(),
    updated_at: row.updated_at,
  };
}

export function mapDbRowToContentImage(row: ContentImageRow): ContentImage {
  return {
    id: row.id,
    campaign_id: row.campaign_id,
    organization_id: row.organization_id,
    folder_id: row.folder_id,
    file_path: row.file_path,
    name: row.name,
    file_name: row.name,
    file_size: row.file_size,
    mime_type: row.mime_type,
    height: row.height,
    width: row.width,
    created_at: row.created_at || new Date().toISOString(),
    updated_at: row.updated_at,
  };
}
